import React from 'react';
import PropTypes from 'prop-types';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

const SrTourDate = ({ tour }) => {
  if (!tour.startDate) {
    return (
      <span
        className='tourDate'
      >
        No tour time chosen...
      </span>
    );
  }

  const today = momentWithAustinTimezone(new Date());
  const tomorrow = momentWithAustinTimezone(new Date()).add(1, 'days');
  const yesterday = momentWithAustinTimezone(new Date()).add(-1, 'days');
  const startDate = momentWithAustinTimezone(tour.startDate);

  let currentDate = startDate.format('MMM Do');

  if (startDate.isSame(today, 'd')) {
    currentDate = 'Today';
  }
  else if (startDate.isSame(yesterday, 'd')) {
    currentDate = 'Yesterday';
  }
  else if (startDate.isSame(tomorrow, 'd')) {
    currentDate = 'Tomorrow';
  }

  return (
    <span className='tourDate'>
      {currentDate} at {startDate.format('h:mm A')}
    </span>
  );
};

SrTourDate.propTypes = {
  tour: PropTypes.object.isRequired,
};

SrTourDate.displayName = 'SrTourDate';

export default SrTourDate;
